import { AppTrans } from '@mntn-dev/app-common'
import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const PreProductionBrandFeedbackSubmitted = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { version, approved, target },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'pre_production_brand_feedback_submitted'>) => {
  const disposition = approved
    ? 'approved'
    : version > 0
      ? 'changes_requested'
      : 'note_added'

  return (
    <ActivityContainer {...{ activity }}>
      <Feed.Summary>
        <AppTrans
          t={t}
          i18nKey={`${activityType}.${disposition}.summary`}
          values={{
            subject: actor.displayName,
            service: target.service,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag
          type={approved ? 'success' : version > 0 ? 'error' : 'info'}
          dataTestId={`activity-feed-item-${activityId}-status-tag`}
          dataTrackingId={`activity-feed-item-${activityId}-status-tag`}
        >
          {t(`${activityType}.${disposition}.status`)}
        </Feed.Tag>
        <Link
          {...{
            target: linkTargetResolver['project-service']({ target }),
            t,
            onNavigate,
            currentUrl,
            dataTestId: `activity-feed-item-${activityId}-view-project-link`,
            dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
          }}
        />
      </Feed.Annotations>
    </ActivityContainer>
  )
}
